angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaLifeInsurerChangeAdditionalDataModalCtrl', ['$scope',
    function($scope) {
      $scope.helper.init();
      $scope.tplData = $scope.helper.tplData;
      $scope.onChooseOtherClient = $scope.helper.onChooseOtherClient;
    }]);
